import gql from 'graphql-tag'

export const COLLECTION = gql`
  query collectionByHandle($handle: String!) {
    collectionByHandle(handle: $handle) {
      id
      title
      handle
      products(first: 10) {
        edges {
          node {
            id
            handle
            title
            tags
            variants(first: 1) {
              edges {
                node {
                  id
                  price {
                    amount
                  }
                  image {
                    originalSrc
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
/* export const ALL_PRODUCTS = gql`query Products {
    products(first: 6) {
      edges {
        cursor
        node {
          handle
          productType
          vendor
          title
          description
          descriptionHtml
          id
          tags
          availableForSale
          collections(first: 5) {
            edges {
              node {
                description
                descriptionHtml
                handle
                title
              }
            }
          }
          metafields(first: 15, namespace: "product_info") {
              edges {
              node {
                key
                value
              }
            }
          }
          images(first: 5) {
            edges {
              node {
                id
                src
                altText
              }
            }
          }
          priceRange {
            maxVariantPrice {
              amount
              currencyCode
            }
            minVariantPrice {
              amount
              currencyCode
            }
          }
  
          variants(first: 5) {
            edges {
              node {
                id
                price
                title
              }
            }
          }
        }
      }
    }
  }
  `; */